<script lang="ts">
  import { ZapFilled } from "$components/+blocks/OVIcon";
  import { NodeViewWrapper } from "svelte-tiptap";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import type { NodeViewProps } from "@tiptap/core";

  export let node: NodeViewProps["node"];
  // $$restProps; // uncomment if you use additional props

  // a simple component that displays the tool name
  // we can enhance this later if needed
  const toolName = node.attrs.tool;
</script>

<NodeViewWrapper
  class="inline-flex h-[25px] items-center gap-1 rounded-md bg-violet-600/80 pr-1.5 pl-1 align-top font-medium text-white dark:bg-violet-600/60 dark:text-white/85"
>
  <OVIcon icon={ZapFilled} class="text-white" size="size-3.5" />
  <span class="leading-[1]">
    {toolName}
  </span>
</NodeViewWrapper>
